import { NotifyHelper } from "../../../helpers/toast";
import { eDotDongTuiActionsObj } from "../../action-types/tct/IDotDongTuiActions";
import { generateActionForKey, generateActions } from "../generateActions";

export const dotDongTuiActions = {
    ...generateActions(eDotDongTuiActionsObj, "DOT_DONG_TUI"),
    ...generateActionForKey(eDotDongTuiActionsObj, "DOT_DONG_TUI", "SAVE_SUCCESS", () => NotifyHelper.Success("Thành công")),
    ...generateActionForKey(eDotDongTuiActionsObj, "DOT_DONG_TUI", "DELETE_SUCCESS", () => NotifyHelper.Success("Thành công")),
    ...generateActionForKey(eDotDongTuiActionsObj, "DOT_DONG_TUI", "SAVE_ERROR", (m) => NotifyHelper.Error(m)),
    ...generateActionForKey(eDotDongTuiActionsObj, "DOT_DONG_TUI", "DELETE_ERROR", (m) => NotifyHelper.Error(m)),
};
